<template>
    <div class="pb-15">

    <v-row>
        <v-col cols="12">
            <h4 class="text-h4">Datos del pedido</h4>
        </v-col>

        <v-col cols="12">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-text>
                            <v-form @submit.prevent="saveTypeOrder">
                                <v-radio-group v-model="typeOrder" @change="saveTypeOrder">
                                    <v-radio
                                        label="Pedido predeterminado (whatsApp automático)"
                                        value="order_auto"
                                    ></v-radio>
                                    <v-radio
                                        label="Pedido previsualizado (whatsApp una vez aceptado/rechazado el pedido)"
                                        value="order_preview"
                                    ></v-radio>
                                    <v-radio
                                        label="Pedido directo (Genera link de whatsApp para el pedido)"
                                        value="order_generate"
                                    ></v-radio>
                                </v-radio-group>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="brown lighten-4">
                        <v-card-title class="justify-center">
                            Datos de forma de entrega
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <!-- delivery -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveDelivery">
                                                <v-switch
                                                    v-model="delivery.enable"
                                                    inset
                                                    :label="`${(delivery.enable)?'Deshabilitar delivery':'Habilitar delivery'}`"
                                                    @change="changeDispatch('saveDelivery')"
                                                ></v-switch>
                                                <v-radio-group v-if="delivery.enable" v-model="delivery.type" @change="changeDispatch('saveDelivery')">
                                                    <v-radio
                                                        label="Precio único"
                                                        value="only_price"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="Precio por km"
                                                        value="km_price"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="Precio por rango"
                                                        value="range_price"
                                                    ></v-radio>
                                                </v-radio-group>
                                                <div v-if="delivery.enable && delivery.type=='only_price' || delivery.type=='km_price'">
                                                    <v-text-field
                                                        :label="(delivery.type=='only_price')?'Precio único':'Precio por km'"
                                                        placeholder="5"
                                                        outlined
                                                        dense
                                                        type="number"
                                                        min="0"
                                                        step="0.1"
                                                        v-model="delivery.value"
                                                        @change="changeDispatch('saveDelivery')"
                                                    ></v-text-field>
                                                </div>
                                                <div v-if="delivery.enable && delivery.type=='km_price'">
                                                    <v-text-field
                                                        label="Monto mínimo a cobrar"
                                                        placeholder="5"
                                                        outlined
                                                        dense
                                                        type="number"
                                                        min="0"
                                                        step="0.1"
                                                        v-model="delivery.valueMin"
                                                        @change="changeDispatch('saveDelivery')"
                                                    ></v-text-field>
                                                </div>
                                                <div v-if="delivery.enable && delivery.type=='range_price'">
                                                    <v-simple-table class="mb-2">
                                                        <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Rango de km
                                                                </th>
                                                                <th>
                                                                    Precio por rango
                                                                </th>
                                                                <th class="text-left">
                                                                    Comentario de entrega (opcional)
                                                                </th>
                                                                <th class="text-right"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in delivery.range" :key="index">
                                                                <td class="px-1">
                                                                    <v-text-field
                                                                        label="Rango de km"
                                                                        outlined
                                                                        dense
                                                                        type="number"
                                                                        v-model="item.maxKm"
                                                                        hide-details
                                                                        @change="changeDispatch('saveDelivery')"
                                                                    ></v-text-field>
                                                                </td>
                                                                <td class="px-1">
                                                                    <v-text-field
                                                                        label="Precio por rango"
                                                                        outlined
                                                                        dense
                                                                        type="number"
                                                                        v-model="item.price"
                                                                        hide-details
                                                                        @change="changeDispatch('saveDelivery')"
                                                                    ></v-text-field>
                                                                </td>
                                                                <td class="px-1">
                                                                    <v-text-field
                                                                        label="Comentario"
                                                                        outlined
                                                                        dense
                                                                        v-model="item.comment"
                                                                        @change="changeDispatch('saveDelivery')"
                                                                        hide-details
                                                                    ></v-text-field>
                                                                </td>
                                                                <td class="text-right px-1">
                                                                    <v-btn
                                                                        icon
                                                                        @click="()=>{ delivery.range.splice(index, 1) }"
                                                                    >
                                                                        <v-icon>mdi-close</v-icon>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="4" class="text-right">
                                                                    <v-btn
                                                                        small
                                                                        dark
                                                                        @click="delivery.range.push({maxKm: '', price: '', comment: ''})"
                                                                    >
                                                                        Añadir
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                        </template>
                                                    </v-simple-table>
                                                </div>
                                                <v-row v-if="delivery.enable && delivery.type=='km_price' || delivery.type=='range_price'">
                                                    <v-col cols="6">
                                                        <v-text-field
                                                            label="Latitud"
                                                            outlined
                                                            dense
                                                            type="number"
                                                            v-model="delivery.lat"
                                                            @change="changeDispatch('saveDelivery')"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-text-field
                                                            label="Longitud"
                                                            outlined
                                                            dense
                                                            type="number"
                                                            v-model="delivery.lng"
                                                            @change="changeDispatch('saveDelivery')"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- delivery END -->
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <!-- comer en local -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveEatLocal">
                                                <v-switch
                                                    v-model="eatLocal.enable"
                                                    inset
                                                    :label="`${(eatLocal.enable)?'Deshabilitar comer en local':'Habilitar comer en local'}`"
                                                    @change="changeDispatch('saveEatLocal')"
                                                ></v-switch>
                                                <div v-if="eatLocal.enable">
                                                    <v-text-field
                                                        label="Descuento en porcentaje"
                                                        placeholder="5"
                                                        outlined
                                                        dense
                                                        type="number"
                                                        min="0"
                                                        step="0.1"
                                                        v-model="eatLocal.value"
                                                        @change="changeDispatch('saveEatLocal')"
                                                    ></v-text-field>
                                                </div>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- comer en local END -->

                                    <!-- order table -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveTable">
                                                <v-switch
                                                    v-model="orderTable"
                                                    inset
                                                    :label="`${(orderTable)?'Deshabilitar ':'Habilitar '}pedidos para la mesa`"
                                                    @change="saveTable"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- order table END -->

                                    <!-- order table -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveOrderProgram">
                                                <v-switch
                                                    v-model="orderProgram"
                                                    inset
                                                    :label="`${(orderProgram)?'Deshabilitar ':'Habilitar '}opción de programar entrega`"
                                                    @change="saveOrderProgram"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- order table END -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="brown lighten-4">
                        <v-card-title class="justify-center">
                            Datos de métodos de pago
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <!-- pago qr -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveCodeQr">
                                                <v-switch
                                                    v-model="payment.enable"
                                                    inset
                                                    :label="`${(payment.enable)?'Deshabilitar pago Qr':'Habilitar pago Qr'}`"
                                                    @change="changeDispatch('saveCodeQr')"
                                                ></v-switch>
                                                <div v-if="payment.enable">
                                                    <v-img
                                                        :src="payment.previewQr"
                                                        contain
                                                        width="100"
                                                        class="mx-auto mb-3"
                                                    ></v-img>
                                                    <v-file-input
                                                        label="Subir código Qr"
                                                        accept="image/png, image/jpeg, image/bmp"
                                                        prepend-icon="mdi-qrcode"
                                                        outlined
                                                        dense
                                                        v-model="payment.codeQr"
                                                        @change="changeDispatch('saveCodeQr')"
                                                    ></v-file-input>
                                                    <!-- @change="changeBanner($event)" -->
                                                    <v-text-field
                                                        label="Banco"
                                                        placeholder="banco Nacional de Bolivia (bnb)"
                                                        outlined
                                                        dense
                                                        v-model="payment.bank"
                                                        @change="changeDispatch('saveCodeQr')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Número de cuenta"
                                                        placeholder="1010101010"
                                                        type="number"
                                                        outlined
                                                        dense
                                                        v-model="payment.account"
                                                        @change="changeDispatch('saveCodeQr')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Nombre"
                                                        placeholder="Juan Peréz"
                                                        outlined
                                                        dense
                                                        v-model="payment.name"
                                                        @change="changeDispatch('saveCodeQr')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Nit"
                                                        placeholder="10555555"
                                                        type="number"
                                                        outlined
                                                        dense
                                                        v-model="payment.nit"
                                                        @change="changeDispatch('saveCodeQr')"
                                                    ></v-text-field>
                                                </div>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- pago qr END -->
                                    <!-- pago banco venezuela -->
                                    <v-card class="mb-5" v-if="country=='ve'">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveBankVen">
                                                <v-switch
                                                    v-model="payment2.enable"
                                                    inset
                                                    :label="`${(payment2.enable)?'Deshabilitar pago PagomóvilBDV':'Habilitar pago PagomóvilBDV'}`"
                                                    @change="changeDispatch('saveBankVen')"
                                                ></v-switch>
                                                <div v-if="payment2.enable">
                                                    <v-img
                                                        :src="payment2.previewImg"
                                                        contain
                                                        width="100"
                                                        class="mx-auto mb-3"
                                                    ></v-img>
                                                    <v-file-input
                                                        label="Subir imagen"
                                                        accept="image/png, image/jpeg, image/bmp"
                                                        prepend-icon="mdi-image"
                                                        outlined
                                                        dense
                                                        v-model="payment2.img"
                                                        @change="changeDispatch('saveBankVen')"
                                                    ></v-file-input>
                                                    <!-- @change="changeBanner($event)" -->
                                                    <v-text-field
                                                        label="Banco"
                                                        outlined
                                                        dense
                                                        v-model="payment2.bank"
                                                        @change="changeDispatch('saveBankVen')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Número de documento"
                                                        outlined
                                                        dense
                                                        v-model="payment2.document"
                                                        @change="changeDispatch('saveBankVen')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Nombre"
                                                        placeholder="Juan Peréz"
                                                        outlined
                                                        dense
                                                        v-model="payment2.name"
                                                        @change="changeDispatch('saveBankVen')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Teléfono"
                                                        outlined
                                                        dense
                                                        v-model="payment2.tel"
                                                        @change="changeDispatch('saveBankVen')"
                                                    ></v-text-field>
                                                </div>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- pago banco venezuela END -->
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <!-- pago tarjeta -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveCard">
                                                <v-switch
                                                    v-model="paymentCard"
                                                    inset
                                                    :label="`${(paymentCard)?'Deshabilitar pago tarjeta de debito/credito':'Habilitar pago tarjeta de debito/credito'}`"
                                                    @change="saveCard"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- pago tarjeta END -->

                                    <!-- pago tarjeta -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveUponDelivery">
                                                <v-switch
                                                    v-model="uponDelivery"
                                                    inset
                                                    :label="`${(uponDelivery)?'Deshabilitar pago contraentrega':'Habilitar pago contraentrega'}`"
                                                    @change="saveUponDelivery"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- pago tarjeta END -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="brown lighten-4">
                        <v-card-title class="justify-center">
                            Datos de ubicación
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="10">
                                    <!-- direcciones -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveAddresses">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Direcciones</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-for="(address, index) in listAddress" :key="index">
                                                        <v-list-item-content>
                                                            <v-row no-gutters>
                                                                <v-col cols="5">
                                                                    <v-text-field
                                                                        :label="`Dirección ${index+1}`"
                                                                        outlined
                                                                        dense
                                                                        hide-details
                                                                        v-model="address.address"
                                                                        @change="changeDispatch('saveAddresses')"
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="5">
                                                                    <v-text-field
                                                                        label="Link google map"
                                                                        outlined
                                                                        dense
                                                                        hide-details
                                                                        type="url"
                                                                        v-model="address.map"
                                                                        class="mb-4"
                                                                        @change="changeDispatch('saveAddresses')"
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="2">
                                                                    <v-btn
                                                                        icon
                                                                        @click="()=>{ listAddress.splice(index, 1); changeDispatch('saveAddresses'); }"
                                                                    >
                                                                        <v-icon>mdi-close</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-btn
                                                            small
                                                            dark
                                                            @click="listAddress.push({address:'', map: ''}), changeDispatch('saveAddresses')"
                                                        >
                                                            Añadir
                                                        </v-btn>
                                                    </v-list-item>
                                                </v-list>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- direcciones END -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="brown lighten-4">
                        <v-card-title class="justify-center">
                            Otros datos
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <!-- consultar wps -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveCosultWps">
                                                <v-switch
                                                    v-model="consultWps"
                                                    inset
                                                    :label="`${(consultWps)?'Deshabilitar ':'Habilitar '}consultar por whatsapp`"
                                                    @change="saveCosultWps"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- consultar wps END -->
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <!-- delivery -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveInvoice">
                                                <v-switch
                                                    v-model="invoice"
                                                    inset
                                                    :label="`${(invoice)?'Deshabilitar facturación':'Habilitar facturación'}`"
                                                    @change="saveInvoice"
                                                ></v-switch>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- delivery END -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" v-if="showFidelityPoints">
                    <v-card class="brown lighten-4">
                        <v-card-title class="justify-center">
                            Puntos de fidelidad
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <!-- consultar wps -->
                                    <v-card class="mb-5">
                                        <v-card-text>
                                            <v-form @submit.prevent="saveFidelityPoints()">
                                                <v-text-field
                                                    label="Enlace para compartir"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    v-model="fidelityPoints"
                                                    @input="changeDispatch('saveFidelityPoints')"
                                                    :disabled="loading13"
                                                    type="url"
                                                ></v-text-field>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <!-- consultar wps END -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>
        </v-col>
    </v-row>

    <!-- bottom -->
    <!-- <v-fab-transition>
        <v-btn
            x-large
            dark
            fixed
            class="sheet-setting"
            v-if="sheet"
            color="primary"
            :loading="loadingAll"
            @click="savedAll"
        >
            Actualizar
        </v-btn>
    </v-fab-transition> -->
    <v-card
        v-if="sheet"
        class="ed-sheet sheet-setting-2 py-3"
        tile
    >
        <v-container>
            <v-row>
                <v-col cols="12" class="text-right">
                    <v-btn
                        color="primary"
                        x-large
                        :loading="loadingAll"
                        @click="savedAll"
                    >Actualizar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
    <!-- end bottom -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            sheet: false,
            loadingAll: false,
            dispatchSaved: [],
            loading: false,
            loading2: false,
            loading3: false,
            loading35: false,
            loading4: false,
            loading5: false,
            loading6: false,
            loading7: false,
            loading8: false,
            loading9: false,
            loading10: false,
            loading11: false,
            loading12: false,
            loading13: false,
            typeOrder: 'order_auto',
            listAddress: [{address:'', map: ''}],
            payment: {
                enable: false,
                codeQr: null,
                bank: '',
                account: '',
                name: '',
                nit: '',
                type: 'code_qr',
                previewQr: ''
            },
            payment2: {
                enable: false,
                img: null,
                bank: '',
                document: '',
                name: '',
                tel: '',
                type: 'bank_ven',
                previewImg: ''
            },
            paymentCard: false,
            uponDelivery: false,
            delivery: {
                enable: false,
                value: null,
                valueMin: null,
                type: 'only_price',
                lat: '',
                lng: '',
                range: [{maxKm: '', price: '', comment: ''}]
            },
            eatLocal: {
                enable: false,
                value: null
            },
            consultWps: false,
            invoice: false,
            orderTable: false,
            orderProgram: true,
            fidelityPoints: ''
            // linkMap: '',
        }
    },
    props: ['slug', 'country', 'showFidelityPoints'],
    mounted() {
        this.getMainData()
    },
    methods: {
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[0]) {
                    const content = JSON.parse(response.data[0].content)
                    this.payment.enable = (content.enable)?true:false
                    this.payment.bank = content.bank
                    this.payment.account = content.account
                    this.payment.name = content.name
                    this.payment.nit = content.nit
                    this.payment.previewQr = content.codeQr
                }
                if (response.data[1]) {
                    const contentAddress = JSON.parse(response.data[1].content)
                    this.listAddress = contentAddress
                }
                if (response.data[2]) {
                    const contentCard = JSON.parse(response.data[2].content)
                    this.paymentCard = (contentCard.enable)?true:false
                }
                if (response.data[3]) {
                    const contentDelivery = JSON.parse(response.data[3].content)
                    // console.log(contentDelivery);
                    this.delivery.enable = (contentDelivery.enable)?true:false
                    this.delivery.value = contentDelivery.price
                    this.delivery.valueMin = contentDelivery.price_min??null
                    this.delivery.type = (contentDelivery.type)?contentDelivery.type:'only_price'
                    this.delivery.lat = (contentDelivery.lat)?contentDelivery.lat:''
                    this.delivery.lng = (contentDelivery.lng)?contentDelivery.lng:''
                    this.delivery.range = (contentDelivery.range)?contentDelivery.range:[{maxKm: '', price: '', comment: ''}]
                }
                if (response.data[4]) {
                    const contentConsult = JSON.parse(response.data[4].content)
                    this.consultWps = (contentConsult.enable)?true:false
                }
                if (response.data[5]) {
                    const contentUponDelivery = JSON.parse(response.data[5].content)
                    this.uponDelivery = (contentUponDelivery.enable)?true:false
                }
                if (response.data[6]) {
                    const contentInvoice = JSON.parse(response.data[6].content)
                    this.invoice = (contentInvoice.enable)?true:false
                }
                if (response.data[7]) {
                    const contentTable = JSON.parse(response.data[7].content)
                    this.orderTable = (contentTable.enable)?true:false
                }
                if (response.data[8]) {
                    const contentMode = JSON.parse(response.data[8].content)
                    this.typeOrder = contentMode.option
                }
                // if (response.data[10]) {
                //     this.linkMap = response.data[10].content
                // }
                if (response.data[11]) {
                    const contentEatLocal = JSON.parse(response.data[11].content)
                    this.eatLocal.enable = (contentEatLocal.enable)?true:false
                    this.eatLocal.value = contentEatLocal.price
                }

                if (response.data[13]) {
                    const contentProgram = JSON.parse(response.data[13].content)
                    this.orderProgram = (contentProgram.enable)?true:false
                }

                if (response.data[14]) {
                    const content = JSON.parse(response.data[14].content)
                    this.payment2.enable = (content.enable)?true:false
                    this.payment2.bank = content.bank
                    this.payment2.document = content.document
                    this.payment2.name = content.name
                    this.payment2.tel = content.tel
                    this.payment2.previewImg = content.imgBank
                }

                if (response.data[15]) {
                    const content = JSON.parse(response.data[15].content)
                    this.fidelityPoints = content.url_fidelity
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },

        /**
         * guardar eventos
         */
        changeDispatch(eventFun) {
            if (!this.dispatchSaved.includes(eventFun)) {
                this.dispatchSaved.push(eventFun)
            }
            // console.log(this.dispatchSaved);
            this.sheet = true
        },
        savedAll() {
            this.loadingAll = true
            // this.sheet = false
            this.dispatchSaved.forEach(element => {
                switch (element) {
                    case 'saveDelivery':
                        this.saveDelivery()
                        break;
                    case 'saveEatLocal':
                        this.saveEatLocal()
                        break;
                    case 'saveCodeQr':
                        this.saveCodeQr()
                        break;
                    case 'saveBankVen':
                        this.saveBankVen()
                        break;
                    case 'saveAddresses':
                        this.saveAddresses()
                        break;
                    case 'saveFidelityPoints':
                        this.saveFidelityPoints()
                    default:
                        break;
                }
            });
            setTimeout(() => {
                this.getMainData()
                this.dispatchSaved = []
                this.sheet = false
                this.loadingAll = false
            }, 300);
        },

        /**
         * save code qr
         */
        async saveCodeQr() {
            this.loading = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Pago por código Qr')
            dataForm.append('enable', (this.payment.enable)?1:0)
            dataForm.append('code', this.payment.codeQr)
            dataForm.append('bank', this.payment.bank)
            dataForm.append('account', this.payment.account)
            dataForm.append('name', this.payment.name)
            dataForm.append('nit', this.payment.nit)
            dataForm.append('type', this.payment.type)
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de pago actualizado con éxito.')
                }
                this.loading = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        },
        /**
         * save banco ven
         */
        async saveBankVen() {
            this.loading12 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Pago por PagomóvilBDV')
            dataForm.append('enable', (this.payment2.enable)?1:0)
            dataForm.append('img', this.payment2.img)
            dataForm.append('bank', this.payment2.bank)
            dataForm.append('document', this.payment2.document)
            dataForm.append('name', this.payment2.name)
            dataForm.append('tel', this.payment2.tel)
            dataForm.append('type', this.payment2.type)
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de pago actualizado con éxito.')
                }
                this.loading12 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading12 = false
            })
        },

        /**
         * save payment card
         */
        async saveCard() {
            this.loading3 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Pago por tarjeta de debito/credito')
            dataForm.append('enable', (this.paymentCard)?1:0)
            dataForm.append('type', 'payment_card')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de pago actualizado con éxito.')
                    this.getMainData()
                }
                this.loading3 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading3 = false
            })
        },

        /**
         * save upon delivery
         */
        async saveUponDelivery() {
            this.loading35 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Pago contraentrega')
            dataForm.append('enable', (this.uponDelivery)?1:0)
            dataForm.append('type', 'upon_delivery')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de pago actualizado con éxito.')
                    this.getMainData()
                }
                this.loading35 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading35 = false
            })
        },

        /**
         * save delivery
         */
        async saveDelivery() {
            this.loading4 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Delivery')
            dataForm.append('enable', (this.delivery.enable)?1:0)
            dataForm.append('price', this.delivery.value?this.delivery.value:null)
            dataForm.append('price_min', this.delivery.valueMin?this.delivery.valueMin:null)
            dataForm.append('type_price', this.delivery.type)
            dataForm.append('range', JSON.stringify(this.delivery.range))
            dataForm.append('lat', this.delivery.lat)
            dataForm.append('lng', this.delivery.lng)
            dataForm.append('type', 'delivery')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de pago actualizado con éxito.')
                }
                this.loading4 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading4 = false
            })
        },

        /**
         * save address
         */
        async saveAddresses() {
            this.loading2 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Direcciones de mi negocio')
            dataForm.append('type', 'addresses')
            dataForm.append('addresses', JSON.stringify(this.listAddress))
            await axios.post('/admin/save-addresses', dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Direcciones actualizadas con exito.')
                }
                this.loading2 = false
            })
            .catch((error) => {
                console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading2 = false
            })
        },

        /**
         * Consult wps
         */
        async saveCosultWps() {
            this.loading5 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Consultar por whatsapp')
            dataForm.append('enable', (this.consultWps)?1:0)
            dataForm.append('type', 'consult_wps')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Consultar por Whatsapp actualizado con éxito.')
                    this.getMainData()
                }
                this.loading5 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading5 = false
            })
        },

        /**
         * save invoice
         */
        async saveInvoice() {
            this.loading6 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Datos de facturación')
            dataForm.append('enable', (this.invoice)?1:0)
            dataForm.append('type', 'invoice')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Datos de facturación actualizado con éxito.')
                    this.getMainData()
                }
                this.loading6 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading6 = false
            })
        },

        /**
         * save order-table
         */
        async saveTable() {
            this.loading7 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Pedidos para la mesa')
            dataForm.append('enable', (this.orderTable)?1:0)
            dataForm.append('type', 'order_table')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Pedidos para la mesa actualizado con éxito.')
                    this.getMainData()
                }
                this.loading7 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading7 = false
            })
        },

        /**
         * type order
         */
        async saveTypeOrder() {
            this.loading8 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Modo de notificación')
            dataForm.append('option', this.typeOrder)
            dataForm.append('type', 'notify_mode')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Modo de notificación actualizado con éxito.')
                }
                this.loading8 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading8 = false
            })
        },

        /**
         * save address
         */
        // async saveLocationMap() {
        //     this.loading9 = true
        //     const dataForm = new FormData()
        //     dataForm.append('owner', this.slug)
        //     dataForm.append('title', 'Ubicación de la tienda en google map')
        //     dataForm.append('type', 'location_map')
        //     dataForm.append('content', this.linkMap)
        //     await axios.post('/admin/save-datapost', dataForm)
        //     .then((response) => {
        //         // console.log(response)
        //         if (response.data == 'ok') {
        //         this.$notify.success('Datos de ubicación actualizado con éxito.')
        //             this.getMainData()
        //         }
        //         this.loading9 = false
        //     })
        //     .catch((error) => {
        //         console.log(error)
        //         if (error.response.data.errors) {
        //             this.errors = error.response.data.errors
        //         }
        //         if (error.response.status == 404 || error.response.status == 500) {
        //             this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
        //         }
        //         this.loading9 = false
        //     })
        // },

        /**
         * save eat local
         */
         async saveEatLocal() {
            this.loading10 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Comer el local')
            dataForm.append('enable', (this.eatLocal.enable)?1:0)
            dataForm.append('price', this.eatLocal.value?this.eatLocal.value:null)
            dataForm.append('type', 'eat-local')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Comer el local actualizado con éxito.')
                }
                this.loading10 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading10 = false
            })
        },

        /**
         * save order-table
         */
         async saveOrderProgram() {
            this.loading11 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Programar entrega')
            dataForm.append('enable', (this.orderProgram)?1:0)
            dataForm.append('type', 'order_program')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Programar entrega actualizado con éxito.')
                    this.getMainData()
                }
                this.loading11 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading11 = false
            })
        },

        /**
         * enlace de puntos de fidelidad
         */
         async saveFidelityPoints() {
            this.loading13 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Enlace de puntos de fidelidad')
            dataForm.append('url_fidelity', this.fidelityPoints)
            dataForm.append('type', 'fidelity_points')
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$notify.success('Enlace de puntos de fidelidad actualizado con éxito.')
                    this.getMainData()
                }
                this.loading13 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading13 = false
            })
        },
    },
}
</script>

<style lang="scss">
.sheet-setting {
    right: 10%;
    bottom: 20px;
    z-index: 4;
    &-2 {
        left: 0;
        right: 0;
        z-index: 4;
    }
}
</style>
